module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg4.8d115dbf.jpg";